import * as React from "react";
import { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { LoginStore } from "modules/login/LoginStore";
import Welcome from "./Welcome";
import WhatToLearn from "./WhatToLearn";

const styles = (theme) => ({
  box: {
    zIndex: 9999,
    position: "absolute" as any,
    top: "0px",
    left: "0px",
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const Tutorial = (props) => {
  const { classes } = props;
  const [firstAccess, setFirstAccess] = useState(
    LoginStore.userAuth!.firstLogin
  );
  const [showTutotial, setShowTutotial] = useState(
    LoginStore.userAuth!.showTutorial
  );
  const [recentLogin, setRecentLogin] = useState(false);

  useEffect(() => {
    let oldUrl = document.referrer;
    let split = oldUrl.split("/");
    let pathname = split[3];

    if (
      ((pathname && pathname.toLowerCase()) === "login" || oldUrl === "") &&
      !LoginStore.recentLogin
    ) {
      LoginStore.recentLogin = true;
      setRecentLogin(true);
    }
  });

  const handleFirstLogin = async () => {
    setFirstAccess(false);
    await LoginStore.ChangeFirstLogin();
  };
  const changeTutorial = async (show) => {
    setShowTutotial(false);
    if (show !== showTutotial) {
      await LoginStore.changeShowTutorial(show);
    }
    setRecentLogin(false);
  };

  if (!LoginStore.expiredTrial() && recentLogin) {
    if (firstAccess)
      return (
        <div className={classes.box}>
          <Welcome handleFirstLogin={handleFirstLogin} />
        </div>
      );

    if (showTutotial)
      return (
        <div className={classes.box}>
          <WhatToLearn
            showTutotial={showTutotial}
            changeTutorial={changeTutorial}
          />
        </div>
      );
  }

  return <></>;
};

export default withStyles(styles)(Tutorial);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/Tutorial.tsx